import {
	defAction
}from "../../../helpers/defaultAction"
import {
	reInfoOrgConstants
}from "./constants"
import downloadFile from "../../../helpers/downloadFile"
import api from './api'

export const reInfoOrgActions = {
	create,
	update,
	remove,
	restore,
	getPaged,
	getPagedAll,
	getList,
	getListByRoles,
	getListByControl,
	clear,
	getExampleFile,
	getFile,
	upload
}

function getExampleFile(){
	const dispatchObj = {
		constants : reInfoOrgConstants.GetExampleFile,
		service   : {
			func: api.getExampleFile
		},
		sucFunction: (res) => downloadFile(res, "Шаблон.xlsx")
	}
	return defAction(dispatchObj)
}

function getFile(){
	const dispatchObj = {
		constants : reInfoOrgConstants.GetExampleFile,
		service   : {
			func: api.getFile
		},
		sucFunction: (res) => downloadFile(res, "Перечень организаций.xlsx")
	}
	return defAction(dispatchObj)
}

function upload(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.Upload,
		service   : {
			func   : api.upload,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.GetPaged,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getListByRoles(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.GetListByRoles,
		service   : {
			func   : api.getListByRoles,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getListByControl(values){
	const dispatchObj = {
		constants : reInfoOrgConstants.GetList,
		service   : {
			func   : api.getListByControl,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
  	return (dispatch) => dispatch({
  		type: reInfoOrgConstants.CLEAR
  	})
}
